<p-dialog
  #fastMotorista
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar motorista</span>
      <i class="mdi mdi-card-account-details-outline ml-2 text-primary"></i>
    </div>
  </ng-template>
  <mat-tab-group>
    <mat-tab label="Dados" style="flex: 1;">
      <ng-template mat-tab-label>
        Dados
        <i
          *ngIf="formDadosValid"
          class="mdi mdi-alert-circle red"
          matTooltip="Preencha as informações corretamente"
        ></i>
      </ng-template>
      <div class="row m-0 pt-1">
        <p-inputGroup class="col-md-12 mt-3">
          <div class="width-100">
            <span class="p-float-label">
              <input
                type="text"
                #cpfCnpjInput
                (click)="cpfCnpjInput.select()"
                id="inputtext-right"
                pInputText
                [formControl]="form.get('cpf_cnpj')"
                [mask]="cpfCnpjMask"
                (animationend)="removeValidatorMask()"
                (blur)="checkCpfCnpj()"
                class="input-filters"
              />
              <p-inputGroupAddon
                [ngClass]="{
                  'p-inputgroup-addon-right': true,
                  'cursor-pointer':
                    !loadingParceiro &&
                    form.get('cpf_cnpj').value &&
                    (form.get('cpf_cnpj').valid ||
                      form.get('cpf_cnpj').disabled)
                }"
                (click)="
                  !loadingParceiro &&
                  form.get('cpf_cnpj').value &&
                  (form.get('cpf_cnpj').valid || form.get('cpf_cnpj').disabled)
                    ? openDialogConsultaPredictus()
                    : null
                "
                [pTooltip]="
                  !loadingParceiro &&
                  form.get('cpf_cnpj').value &&
                  (form.get('cpf_cnpj').valid || form.get('cpf_cnpj').disabled)
                    ? 'Consultar dados'
                    : ''
                "
              >
                <i
                  [class]="
                    !form.get('cpf_cnpj').value || form.get('cpf_cnpj').invalid
                      ? 'pi pi-fw pi-search text-gray'
                      : loadingParceiro
                      ? 'pi pi-fw pi-spin cursor-pointer pi-spinner text-primary'
                      : 'pi pi-fw pi-search cursor-pointer text-primary'
                  "
                ></i>
              </p-inputGroupAddon>
              <label for="inputtext-right">CPF/CNPJ</label>
            </span>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('repeated')
              "
            >
              {{ messages.cpf_cnpj.repeated }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('required')
              "
            >
              {{ messages.cpf_cnpj.required }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('pattern')
              "
            >
              {{ messages.cpf_cnpj.pattern }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('duplicate')
              "
            >
              {{ messages.cpf_cnpj.duplicate }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('maxlength')
              "
            >
              {{ messages.cpf_cnpj.maxlength }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCPF')
              "
            >
              {{ messages.cpf_cnpj.validateCPF }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCNPJ')
              "
            >
              {{ messages.cpf_cnpj.validateCNPJ }}
            </small>
          </div>
        </p-inputGroup>
        <div class="flex-column col-md-12 mt-3">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>Nome/razão social</mat-label>
            <input
              matInput
              type="text"
              [formControl]="form.get('nome_razao_social')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('required')
            "
          >
            {{ messages.nome_razao_social.required }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('maxlength')
            "
          >
            {{ messages.nome_razao_social.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('minlength')
            "
          >
            {{ messages.nome_razao_social.minlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('isEmptyValue')
            "
          >
            {{ messages.nome_razao_social.isEmptyValue }}
          </small>
        </div>
        <div class="flex-column col-md-12 mt-3">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>Apelido/nome fantasia</mat-label>
            <input
              matInput
              type="text"
              [formControl]="form.get('apelido_nome_fantasia')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('maxlength')
            "
          >
            {{ messages.apelido_nome_fantasia.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('minlength')
            "
          >
            {{ messages.nome_razao_social.minlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('isEmptyValue')
            "
          >
            {{ messages.nome_razao_social.isEmptyValue }}
          </small>
        </div>

        <div class="flex-column col-md-6 mt-3">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>Inscrição estadual/RG</mat-label>
            <input
              matInput
              type="text"
              (keydown)="notText($event)"
              (blur)="checkRgInscEstadual()"
              [formControl]="form.get('rg_insc_est')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('rg_insc_est').touched &&
              form.get('rg_insc_est').hasError('pattern')
            "
          >
            {{ messages.rg_insc_est.pattern }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('rg_insc_est').touched &&
              form.get('rg_insc_est').hasError('maxlength')
            "
          >
            {{ messages.rg_insc_est.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="form.get('rg_insc_est').hasError('existSpecialChar')"
          >
            {{ messages.rg_insc_est.existSpecialChar }}
          </small>
          <small
            class="p-error"
            *ngIf="form.get('rg_insc_est').hasError('isEmptyValue')"
          >
            {{ messages.rg_insc_est.isEmptyValue }}
          </small>
        </div>
        <div class="flex-column col-md-6 mt-3">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>CNH</mat-label>
            <input
              matInput
              type="text"
              (blur)="checkCNH()"
              (keydown)="notText($event)"
              [formControl]="form.get('cnh')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('cnh').touched && form.get('cnh').hasError('duplicate')
            "
          >
            {{ messages.cnh.duplicate }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('cnh').touched && form.get('cnh').hasError('required')
            "
          >
            {{ messages.cnh.required }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('cnh').touched && form.get('cnh').hasError('maxlength')
            "
          >
            {{ messages.cnh.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('cnh').touched &&
              form.get('cnh').hasError('isEmptyValue')
            "
          >
            {{ messages.cnh.isEmptyValue }}
          </small>
        </div>
        <div class="col-md-4 mt-3">
          <mat-form-field appearance="outline" class="width-100">
            <mat-label>CNH categoria</mat-label>
            <mat-select [formControl]="form.get('cnh_categoria')">
              <mat-option *ngFor="let i of tipoCategoria" [value]="i.value">
                {{ i.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <small
            *ngIf="form.get('cnh_categoria').hasError('required')"
            class="p-error"
          >
            {{ messages.cnh_categoria.required }}
          </small>
        </div>
        <div class="col-md-4 mt-3">
          <mat-form-field
            appearance="outline"
            color="primary"
            class="width-100"
          >
            <mat-label>Validade da CNH</mat-label>
            <input
              [id]="ID_FIELD_DTCNH"
              matInput
              (focus)="onFocus($event, true)"
              (blur)="
                focusElement === ID_DTPICKER_CNH ? null : onFocus(null, false)
              "
              appFormatData
              [formControl]="form.get('cnh_validade')"
              [matDatepicker]="dataPickerCnh"
            />
            <mat-datepicker-toggle
              *ngIf="
                inputElementDtCNH
                  ? inputElementDtCNH
                  : !form.get('cnh_validade').value
                  ? focusElement === ID_FIELD_DTCNH ||
                    focusElement === ID_DTPICKER_CNH
                  : focusElement === ID_FIELD_DTCNH ||
                    form.get('cnh_validade').value
              "
              (click)="onFocus({ target: { id: ID_DTPICKER_CNH } })"
              (mouseover)="onFocus({ target: { id: ID_DTPICKER_CNH } })"
              (mouseout)="onFocus(null)"
              matSuffix
              [for]="dataPickerCnh"
            ></mat-datepicker-toggle>
            <mat-datepicker
              #dataPickerCnh
              color="primary"
              (closed)="onFocus(null, false)"
            ></mat-datepicker>
          </mat-form-field>
          <small
            class="p-error"
            id="error-data-nascimento"
            *ngIf="form.get('cnh_validade').hasError('required')"
          >
            Validade da CNH é obrigatória!
          </small>
          <small
            class="p-error"
            id="error-data-nascimento"
            *ngIf="form.get('cnh_validade').hasError('matDatepickerParse')"
          >
            Esta data é invalida.
          </small>
          <small
            class="p-error"
            id="error-data-nascimento"
            *ngIf="form.get('cnh_validade').hasError('invalidDate')"
          >
            Data não pode ser posterior a atual
          </small>
          <small
            class="p-error"
            id="error-data-nascimento"
            *ngIf="form.get('cnh_validade').hasError('isEmptyValue')"
          >
            Valor inválido remova os espaços em branco
          </small>
        </div>
        <div class="col-md-4 mt-3">
          <mat-form-field
            appearance="outline"
            color="primary"
            class="width-100"
          >
            <mat-label>Data de nascimento/Data de abertura</mat-label>
            <input
              [id]="ID_FIELD_DTNASC"
              matInput
              (focus)="onFocus($event, true)"
              (blur)="
                focusElement === ID_DTPICKER_NASC ? null : onFocus(null, false)
              "
              appFormatData
              [formControl]="form.get('data_nascimento')"
              [matDatepicker]="dataPicker"
            />
            <mat-datepicker-toggle
              *ngIf="
                inputElementDtNasc
                  ? inputElementDtNasc
                  : !form.get('data_nascimento').value
                  ? focusElement === ID_FIELD_DTNASC ||
                    focusElement === ID_DTPICKER_NASC
                  : focusElement === ID_FIELD_DTNASC ||
                    form.get('data_nascimento').value
              "
              (click)="onFocus({ target: { id: ID_DTPICKER_NASC } })"
              (mouseover)="onFocus({ target: { id: ID_DTPICKER_NASC } })"
              (mouseout)="onFocus(null)"
              matSuffix
              [for]="dataPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker
              #dataPicker
              color="primary"
              (closed)="onFocus(null, false)"
            ></mat-datepicker>
          </mat-form-field>
          <small
            class="p-error"
            id="error-data-nascimento"
            *ngIf="form.get('data_nascimento').hasError('matDatepickerParse')"
          >
            Esta data é invalida.
          </small>
          <small
            class="p-error"
            id="error-data-nascimento"
            *ngIf="form.get('data_nascimento').hasError('invalidDate')"
          >
            Data não pode ser posterior a atual
          </small>
          <small
            class="p-error"
            id="error-data-nascimento"
            *ngIf="form.get('data_nascimento').hasError('isEmptyValue')"
          >
            Valor inválido remova os espaços em branco
          </small>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Endereço" style="flex: 1;">
      <ng-template mat-tab-label>
        Endereço
        <i
          *ngIf="formAddressValid"
          class="mdi mdi-alert-circle red"
          matTooltip="Preencha as informações corretamente"
        ></i>
      </ng-template>
      <app-fast-endereco [entity]="entity.parceiro"></app-fast-endereco>
    </mat-tab>
    <mat-tab label="Contatos">
      <app-fast-contato [entity]="entity.parceiro"></app-fast-contato>
    </mat-tab>
  </mat-tab-group>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        mat-dialog-close
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="!formValid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
